import { requst } from './config'

/* 获取用户个人资料 */
export const getUserProfileApi = () => {
    const url = `/system/user/profile`
    return requst.get(url)
}

/* 上传头像 */
export const postProfileAvatarApi = file => {
    const formData = new FormData()
    formData.append('avatarfile', file)
    const url = `/system/user/profile/avatar`
    return requst({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    })
}

/* 更新用户信息 */
export const postProfileApi = params => {
    const url = `/system/user/profile`
    return requst.put(url, { ...params })
}

/* 修改用户密码 */
export const putUpdatePasswordApi = params => {
    const url = `/system/user/profile/updatePwd?oldPassword=${encodeURIComponent(
        params.oldPassword
    )}&newPassword=${encodeURIComponent(params.newPassword)}`
    return requst.put(url)
}
